import React from "react";
import { Row, Col, Card, Progress, Table, Typography } from "antd";

import "../../../assets/dist/ConsumerProject/Consumer/ConsumerDashboardNewStyle.css"

const { Text } = Typography;

const columns = [
  { title: "Fund", dataIndex: "fund" },
  { title: "Asset Class", dataIndex: "asset" },
  { title: "Vintage", dataIndex: "vintage" },
  {
    title: "IRR",
    dataIndex: "irr",
    render: (val) => <span className="positive">{val}</span>
  },
  { title: "MOIC", dataIndex: "moic" }
];

const ConsumerDashboardPortfolio = () => {
 const allocationData = [
  { label: "Venture Capital", value: 35 },
  { label: "Buyout", value: 28 },
  { label: "Real Estate", value: 20 },
  { label: "Private Credit", value: 12 },
  { label: "Growth Equity", value: 5 }
];

 const recentActivity = [
  {
    title: "Capital Call - Sequoia Capital Fund XVI",
    meta: "$2.5M • 2 days ago"
  },
  {
    title: "Distribution - KKR Americas Fund XIII",
    meta: "$4.2M • 5 days ago"
  },
  {
    title: "Valuation Update - Apollo Credit Fund IV",
    meta: "Q4 2025 • 1 week ago"
  },
  {
    title: "New Commitment - TPG Growth V",
    meta: "$10M • 2 weeks ago"
  },
  {
    title: "Tax Document - K-1 Forms Available",
    meta: "Multiple funds • 3 weeks ago"
  }
];

const topFunds = [
  {
    key: 1,
    fund: "KKR Americas Fund XIII",
    asset: "Buyout",
    vintage: 2018,
    irr: "+24.1%",
    moic: "1.30x"
  },
  {
    key: 2,
    fund: "Sequoia Capital Fund XVI",
    asset: "Venture Capital",
    vintage: 2021,
    irr: "+18.2%",
    moic: "1.14x"
  },
  {
    key: 3,
    fund: "TPG Growth V",
    asset: "Growth Equity",
    vintage: 2020,
    irr: "+14.9%",
    moic: "1.15x"
  },
  {
    key: 4,
    fund: "Blackstone Real Estate Partners IX",
    asset: "Real Estate",
    vintage: 2019,
    irr: "+12.5%",
    moic: "1.13x"
  }
];

  return (
    <>
      {/* Top Section */}
      <Row gutter={[16, 16]} className="portofolioROwMain" >
        <Col xs={24} lg={12}>
          <Card className="dark-card cardViewMain H100" title="Portfolio Allocation" >
            {allocationData.map((item) => (
              <div key={item.label} className="allocation-row">
                <div className="allocation-header">
                  <Text>{item.label}</Text>
                  <Text>{item.value}%</Text>
                </div>
                <Progress
                  percent={item.value}
                  showInfo={false}
                  strokeColor="#41746E"
                  trailColor="#2a2a2a"
                />
              </div>
            ))}
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card className="dark-card cardViewMain" title="Recent Activity">
            {recentActivity.map((item, index) => (
              <div key={index} className="activity-item">
                <Text className="activity-title">{item.title}</Text>
                <Text className="activity-meta">{item.meta}</Text>
              </div>
            ))}
          </Card>
        </Col>
      </Row>

      {/* Bottom Section */}
      <Row style={{ marginTop: 16 }}>
        <Col span={24}>
          <Card className="dark-card topPerformingInvestMentTable cardViewMain" title="Top Performing Investments">
            <Table
              columns={columns}
              dataSource={topFunds}
              pagination={false}
              className="dark-table"
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ConsumerDashboardPortfolio;
